import {forceScrollSmootherUpdate} from "../utility/gsap";

export const InitForms = () => {
  const forms = document.querySelectorAll('.gform_wrapper');
  if(forms){
    forms.forEach(form => {
      form.tdForm = new tdForm(form);
    });
  }
}

class tdForm{
  constructor(formEl){
    this.block = formEl;
    
    this.init();
  }

  init(){
    this.form = this.block.querySelector('form');
    this.fields = this.getFieldData();
    this.body = this.block.querySelector('.gform_body');
    this.footer = this.block.querySelector('.gform_footer');
    this.submit = this.block.querySelector('button[type="submit"]');

    this.adjustFormMarkup();
    this.handleInputActiveState();
    this.watchAjaxSubmit();
  }

  adjustFormMarkup() {
    const bodyFooterWrap = document.createElement("div");
    bodyFooterWrap.classList.add('tdFormWrap');
    bodyFooterWrap.appendChild(this.body);

    if(this.footer){
      bodyFooterWrap.appendChild(this.footer);
    }

    this.form.appendChild(bodyFooterWrap);
  }

  getFieldData(fields = false){
    fields = fields ? fields : this.block.querySelectorAll('.gfield');
    let fieldsData = [];
    fields.forEach(field => {

      let fieldData = {};
      fieldData.wrapper = field;
      fieldData.input = field.querySelector('.ginput_container textarea, .ginput_container input, .ginput_container select');
      fieldData.label = field.querySelector('.gfield_label');
      
      if(fieldData.wrapper && fieldData.wrapper.classList.contains('gfield--type-html')){
        fieldData.type = 'html';
      }
      else if(fieldData.input.classList.contains('datepicker')){
        fieldData.type = 'date';
      } 
      else if (fieldData.input.classList.contains('textarea')){
        fieldData.type = 'textarea';
      }
      else if(fieldData.input.classList.contains('gfield_select')){
        fieldData.type = 'select';
      }
      else {
        fieldData.type = 'text';
      }

      fieldsData.push(fieldData);
    });

    return fieldsData;
  }

  handleInputActiveState(){
    this.fields.forEach((field, index) => {
      if(!field.initialized){
        field.initialized = true;

        this.checkSelectPlaceholderPresence(field);

        this.prepPlaceholderAttr(field);

        this.setInputActiveState(field); // run on load

        if(field.input){
          field.input.addEventListener('focus', () => {
            field.input.classList.add('focus');
            this.setInputActiveState(field);
            this.setPlaceholderState(field);
          });
          field.input.addEventListener('change', () => {
            this.setInputActiveState(field);
            this.setPlaceholderState(field);
          });
          field.input.addEventListener('focusout', () => {
            field.input.classList.remove('focus');
            this.setInputActiveState(field);
            this.setPlaceholderState(field);
          });
        }
      }
    });
  }

  setInputActiveState(field) {
    const isFocused = field.input.classList.contains('focus');
  
    if(isFocused || field.input.value){
      field.wrapper.classList.add('input_initiated');
    }
    else {
      field.wrapper.classList.remove('input_initiated');
    }

    // Select Field Specific
    // Check if selected option is a placeholder option and equal to the label 
    if(field.type == 'select'){
      const placeholderOption = field.input.querySelector('option.gf_placeholder');
      if(placeholderOption && !field.input.value){
        if(placeholderOption.innerHTML == field.label.innerText){
          field.wrapper.classList.add('hide_label');
        }
      }
      else if(field.wrapper.classList.contains('hide_label')){
        field.wrapper.classList.remove('hide_label');
      }
    }
  }

  setPlaceholderState(field) {
    const placeholder = field.input.getAttribute('data-placeholder');
  
    if(placeholder){
      const isFocused = field.input.classList.contains('focus');
    
      if(isFocused && !field.input.value){
        field.input.setAttribute('placeholder', placeholder);
      }
      else {
        field.input.setAttribute('placeholder', '');
      }
    }
  }

  prepPlaceholderAttr(field) {
    const placeholder = field.input.getAttribute('placeholder');
  
    if(placeholder){
      field.input.classList.add('has_placeholder');
      field.input.setAttribute('data-placeholder', placeholder);
      field.input.removeAttribute('placeholder');
    }
  }

  checkSelectPlaceholderPresence(field) {
    if(field.type == 'select'){
      const placeholderOption = field.input.querySelector('option.gf_placeholder');
      
      if(!placeholderOption){
        field.wrapper.classList.add('force_input_initiated');
      }
    }
  };

  watchAjaxSubmit() {
    let interval = false;
    let i = 0;
    this.submit.addEventListener('click', ()=>{
      ajaxEventHandler();
    });

    const ajaxEventHandler = () => {
      if(!interval){
        interval = setInterval(()=>{
          i++;
          const ajaxSpinner = this.block.querySelector('.gform_ajax_spinner');
          
          // Check if the ajax loading is done
          const isComplete = !!ajaxSpinner ? false : true;
          if(isComplete || i > 50){
            this.init();

            setTimeout(()=>{
              forceScrollSmootherUpdate();
              window.dispatchEvent(new Event('resize'));
            }, 500);

            // End the check.
            clearTimeout(interval);
            i = 0;
            interval = false;
          }
        }, 50);
      }
    }
  }
}

